module.exports = __webpack_public_path__ + "static/media/008.d5915e5e.jpg";